/**
 * utils
 */
export default class {

	constructor() {}

	/**
	 * observer
	 */
	 observer(target, callback) {
	 	const obs = new MutationObserver(callback);
	 	obs.observe(target, { childList: true });
	 	return obs;
	}

	/**
	 * print
	 */
	print() {
		$('.js-modal--white-print').click(function() {
			$('body').addClass('is-modal--white-print');

			window.addEventListener('afterprint', (function(x) {
				$('body').removeClass('is-modal--white-print');
				return function f() {
					window.removeEventListener('afterprint');
				}
			}));
			window.print();
		});
	}

	/**
	 * sessionチェック
	 */
	checkSession(jqXHR) {
		if(jqXHR == 403) {
			// CSRFハッシュ期限切れ
			location.reload();
			return false;
		}

		$.ajax({
		    type: "GET",
		    url: '/signin/check',
		    dataType: 'json',
		    timeout: 5000,
			async: false
	    }).always(function (data) {
	        if(data.result) return false;
			location.href = '/signin';
	    });
	}
}

